window.onload = function(event) {
	
	var sellingplanid = "";
	/**
	 * Wait for an element before resolving a promise
	 * @param {String} querySelector - Selector of element to wait for
	 * @param {Integer} timeout - Milliseconds to wait before timing out, or 0 for no timeout              
	 */
	function waitForElement(querySelector, timeout){
	  return new Promise((resolve, reject)=>{
		var timer = false;
		if(document.querySelectorAll(querySelector).length) return resolve();
		const observer = new MutationObserver(()=>{
		  if(document.querySelectorAll(querySelector).length){
			observer.disconnect();
			if(timer !== false) clearTimeout(timer);
			return resolve();
		  }
		});
		observer.observe(document.body, {
		  childList: true, 
		  subtree: true
		});
		if(timeout) timer = setTimeout(()=>{
		  observer.disconnect();
		  reject();
		}, timeout);
	  });
	}
	
	var loadwait = 500;
	waitForElement(".rc-widget", loadwait).then(function(){
		//console.log(".rc-widget is loaded.. do stuff");
		//---------------		
		function variant_listener(variantName){
		  //console.log("variant: "+variantName);
		  var rcwidgets = document.getElementsByClassName("recharge-subscription-widget");
		  var singlepricediv = document.querySelector('.single-price');
		  var sellingplaninput = document.getElementsByName("selling_plan")[0];
		  var sellingplansdiv = document.getElementsByClassName("rc-selling-plans");
		  var rctitle = document.querySelector(".rc-title");
		  
		  rctitle.classList.remove("hidden");
		  
		  if(variantName == "30g"){
			// hide all instances of rcwidget
			for (let i = 0; i < rcwidgets.length; i++) {
			  rcwidgets[i].style.display = 'none';
			}
			// change hidden input selling plan value to empty
			sellingplanid = sellingplaninput.value;
			sellingplaninput.value = "";
			
			singlepricediv.classList.remove("transform");
			singlepricediv.classList.add("active");
		  }else{
			// show all instances of rcwidget
			for (let i = 0; i < rcwidgets.length; i++) {
			  rcwidgets[i].style.display = 'block';
			}
			singlepricediv.classList.add("transform");
			
			//console.log("sellingplansdiv: "+sellingplansdiv.length);
			if(sellingplansdiv.length > 0){
			  singlepricediv.classList.remove("active");
			  if(sellingplanid){         
				sellingplaninput.value = sellingplanid;
			  }
			}else{
			  singlepricediv.classList.add("active");
			}
		  }
		  //console.log("sellingplaninput: "+sellingplaninput.value);
		}
		var radios = document.getElementsByClassName("variant-radio");
		for(var i = 0, max = radios.length; i < max; i++) {
			radios[i].onclick = function() {
			  //alert(this.value);
			  variant_listener(this.value);
			}
		}
		// check current or default pre-selected variant and send via function above
		// "productvarianttitle" defined in product template before inclusion of this js file
		variant_listener(productvarianttitle);
		
		function check_selected(obj){
		  //console.log("obj: " + obj);
		  var isOnetime = obj.classList.contains("onetime-radio");
		  var singlepricediv = document.querySelector('.single-price');
		  if(isOnetime){
			singlepricediv.classList.add("active");
		  }else{
			singlepricediv.classList.remove("active");
		  }
		}
		var rcradios = document.getElementsByClassName("rc-radio");
		for(var i = 0, max = rcradios.length; i < max; i++) {
			rcradios[i].onclick = function() {
			  check_selected(this);
			}
		}
		// insert text into widget subscription
		var rcradiosubscription = document.getElementsByClassName('rc-radio__subscription')[0];
		var rcradiosubscription_txt = "<span class='rc-subscription-description'>- Select your favourites<br>- Choose your delivery<br>- Amend at any time</span>";
		rcradiosubscription.innerHTML += rcradiosubscription_txt;
		
		//----------------------------------
		// check if single-price has changed
		//----------------------------------
		var moneyspanparent = document.querySelector('#price-wrapper');
		var moneyspan = moneyspanparent.getElementsByClassName("money")[0];
		var rcmoneyspanparent = document.querySelector('.onetime-radio');
		var rcmoneyspan = rcmoneyspanparent.querySelector('.rc-radio__label');
		//console.log("money: "+rcmoneyspan.innerHTML);
		var mutateObserver = new MutationObserver(function(records) {
		  //console.log(records);
		  changeOnetimePrice();
		  changeStrikePrice();
		});
		mutateObserver.observe(rcmoneyspan, {
		  childList: true,             // capture child add/remove on target element.
		  characterData: true,         // capture text changes on target element
		  subtree: true,               // capture childs changes too
		  characterDataOldValue: true  // keep of prev value
		});
		function changeOnetimePrice(){
			let onetimeprice = getOnetimePrice();   
			//update one-time price display (quicker than natively)
			let moneyspanparent = document.querySelector('#price-wrapper');
			let moneyspan = moneyspanparent.querySelector('.money');
			moneyspan.innerHTML = onetimeprice;
		}
		function getOnetimePrice(){
			let onetimeradio = document.getElementsByClassName("onetime-radio")[0].getElementsByClassName("rc-radio__label")[0];
			  let onetimetext = onetimeradio.innerHTML;
			  let onetimetextpos = onetimetext.search("£");
			  let onetimeprice = onetimetext.slice(onetimetextpos);
			  //console.log("onetimetext: "+onetimetext);
			  //console.log("onetimeprice: "+onetimeprice);
			return onetimeprice;
		}
		function changeStrikePrice(){
			let onetimeprice = getOnetimePrice();
			let rcsubspanparent = document.querySelector('.subscription-radio');
			let rcstrikepricespan = rcsubspanparent.querySelector('.rc-radio__price-strike');
			rcstrikepricespan.innerHTML = onetimeprice;		
		}
		function addStrikePrice(){
			let onetimeprice = getOnetimePrice();
			// add one-time price to subscription box
			let rcsubspanparent = document.querySelector('.subscription-radio');
			let rcsubmoneyspan = rcsubspanparent.querySelector('.rc-radio__subscription');
			//let rcsubdiscountedspan = rcsubspanparent.querySelector('.rc-radio__price');
			let strikeprice = "<span class='rc-radio__price-strike'>"+onetimeprice+"</span>";
			//let discountedprice = (onetimeprice.slice(1, onetimeprice.length)*.9).toFixed(2);
			//console.log("strikeprice: "+strikeprice);
			//console.log("discountedprice: "+discountedprice);
			//console.log("target: "+rcsubmoneyspan.innerHTML);
			rcsubmoneyspan.innerHTML += strikeprice;
		  }
		addStrikePrice();
		// unhide recharge-subscription-widget && single-price
		var rcwidget = document.getElementsByClassName('recharge-subscription-widget')[0];
		rcwidget.classList.add("loaded");
		var singlepricediv = document.querySelector('.single-price');
		singlepricediv.classList.add("loaded");
		loadMedia();
	}).catch(()=>{
		var loadsecs = loadwait/1000
		//console.log(".rcwidget element did not load in "+loadsecs+" seconds");
		var singlepricediv = document.querySelector('.single-price');
		singlepricediv?.classList.add("loaded");
		singlepricediv?.classList.add("active");
		loadMedia();
	});
	
	function loadMedia(){
		var slider_setting = {
			prevNextButtons: true,
			pageDots: false,
			wrapAround: true,
			selectedAttraction: 0.1,
			setGallerySize: false,
			imagesLoaded: true,
			friction: 0.5,
			draggable: true,
			cellAlign: 'center'
		  };
		  var flkty;
		  flkty = new Flickity(".product-carousel",slider_setting);
	}
	
  };